/* PAPPOS — fotos del producto en pantalla completa con zoom (sin apps).
   PC: el cursor es lupa; clic abre la galería grande; dentro, clic acerca y la foto sigue al mouse; +/− y flechas.
   Celular: un toque abre pantalla completa; dos dedos o doble toque acercan; deslizar cambia de foto.
   Fotos: <script data-pp-zoom> en sections/pp-main-product.liquid. Estilos: .pp-zoom en la misma sección. */
(() => {
  const gal = document.querySelector('pp-gallery');
  const data = document.querySelector('script[data-pp-zoom]');
  if (!gal || !data) return;
  let photos;
  try { photos = JSON.parse(data.textContent); } catch (e) { return; }
  if (!photos.length) return;

  const title = data.dataset.title || '';
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CLICK = 2.5; const MAX = 3;
  const svg = (d, w) => '<svg width="' + (w || 22) + '" height="' + (w || 22) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + d + '</svg>';
  const IC = {
    plus: svg('<path d="M12 5v14M5 12h14"/>'),
    minus: svg('<path d="M5 12h14"/>'),
    close: svg('<path d="M6 6l12 12M18 6L6 18"/>'),
    prev: svg('<path d="M15 6l-6 6 6 6"/>', 24),
    next: svg('<path d="M9 6l6 6-6 6"/>', 24)
  };

  let dlg, track, countEl, hintEl, btnIn, btnOut, thumbs = [], slides = [];
  let idx = 0; let s = 1; let tx = 0; let ty = 0;

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'pp-zoom';
    dlg.setAttribute('aria-label', 'Fotos de ' + title);
    dlg.innerHTML =
      '<div class="pp-zoom__thumbs" role="group" aria-label="Miniaturas"></div>' +
      '<div class="pp-zoom__bar"><span class="pp-zoom__count" aria-live="polite"></span><div class="pp-zoom__tools">' +
        '<button class="pp-zoom__btn" type="button" data-z="in" aria-label="Acercar">' + IC.plus + '</button>' +
        '<button class="pp-zoom__btn" type="button" data-z="out" aria-label="Alejar">' + IC.minus + '</button>' +
        '<button class="pp-zoom__btn" type="button" data-z="close" aria-label="Cerrar fotos">' + IC.close + '</button>' +
      '</div></div>' +
      '<div class="pp-zoom__stage"><div class="pp-zoom__track"></div>' +
        (photos.length > 1 ? '<button class="pp-zoom__btn pp-zoom__nav pp-zoom__nav--prev" type="button" data-z="prev" aria-label="Foto anterior">' + IC.prev + '</button>' +
        '<button class="pp-zoom__btn pp-zoom__nav pp-zoom__nav--next" type="button" data-z="next" aria-label="Foto siguiente">' + IC.next + '</button>' : '') +
        '<p class="pp-zoom__hint" aria-hidden="true"></p></div>';
    track = dlg.querySelector('.pp-zoom__track');
    countEl = dlg.querySelector('.pp-zoom__count');
    hintEl = dlg.querySelector('.pp-zoom__hint');
    btnIn = dlg.querySelector('[data-z=in]');
    btnOut = dlg.querySelector('[data-z=out]');
    const tbox = dlg.querySelector('.pp-zoom__thumbs');
    photos.forEach((p, i) => {
      const fig = document.createElement('figure');
      fig.className = 'pp-zoom__slide';
      const img = document.createElement('img');
      img.alt = title + ', foto ' + (i + 1) + ' de ' + photos.length;
      img.draggable = false;
      img.decoding = 'async';
      if (p.w && p.h) { img.width = p.w; img.height = p.h; }
      fig.appendChild(img);
      track.appendChild(fig);
      slides.push({ fig, img, src: p.src });
      if (photos.length > 1) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'pp-zoom__thumb';
        b.setAttribute('aria-label', 'Ver foto ' + (i + 1));
        b.innerHTML = '<img src="' + p.thumb + '" alt="" loading="lazy" draggable="false">';
        b.addEventListener('click', () => go(i, true));
        tbox.appendChild(b);
        thumbs.push(b);
      }
    });
    dlg.addEventListener('click', (e) => {
      const b = e.target.closest('[data-z]');
      if (!b) return;
      const z = b.dataset.z;
      if (z === 'close') dlg.close();
      else if (z === 'prev') go(idx - 1, true);
      else if (z === 'next') go(idx + 1, true);
      else if (z === 'in' || z === 'out') {
        const r = rect();
        zoomAt(z === 'in' ? Math.min(MAX, Math.floor(s) + 1) : Math.max(1, Math.ceil(s) - 1), r.width / 2, r.height / 2, true);
      }
    });
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1, true); }
      else if (e.key === '+' || e.key === '=') { const r = rect(); zoomAt(Math.min(MAX, s + 1), r.width / 2, r.height / 2, true); }
      else if (e.key === '-') { const r = rect(); zoomAt(Math.max(1, s - 1), r.width / 2, r.height / 2, true); }
    });
    dlg.addEventListener('close', onClose);
    window.addEventListener('resize', () => { if (dlg.open) { reset(); go(idx, false); } });
    gestures();
    document.body.appendChild(dlg);
  }

  const rect = () => slides[idx].fig.getBoundingClientRect();
  /* Mientras baja la foto grande se muestra la que ya cargó la galería de la ficha (no se ve en blanco). */
  function load(i) {
    [i, i + 1, i - 1].forEach((k) => {
      const sl = slides[k];
      if (!sl || sl.started) return;
      sl.started = true;
      const g = items[k] && items[k].querySelector('img');
      const low = g && g.complete && g.naturalWidth ? g.currentSrc : '';
      if (!low) { sl.img.src = sl.src; return; }
      sl.img.src = low;
      const hi = new Image();
      hi.onload = () => { sl.img.src = sl.src; };
      hi.src = sl.src;
    });
  }
  function apply(animate) {
    const sl = slides[idx];
    sl.img.style.transition = animate && !reduce ? 'transform .22s ease' : 'none';
    sl.img.style.transform = s > 1 ? 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')' : '';
    sl.fig.classList.toggle('is-zoomed', s > 1);
    if (btnIn) btnIn.disabled = s >= MAX;
    if (btnOut) btnOut.disabled = s <= 1;
  }
  function clamp() {
    const r = rect();
    tx = Math.min(0, Math.max(r.width * (1 - s), tx));
    ty = Math.min(0, Math.max(r.height * (1 - s), ty));
  }
  function zoomAt(ns, cx, cy, animate) {
    ns = Math.min(MAX, Math.max(1, ns));
    const px = (cx - tx) / s; const py = (cy - ty) / s;
    s = ns;
    if (s === 1) { tx = 0; ty = 0; } else { tx = cx - s * px; ty = cy - s * py; clamp(); }
    apply(animate);
  }
  function reset() { if (!slides[idx]) return; s = 1; tx = 0; ty = 0; apply(false); }

  function go(i, smooth) {
    const n = photos.length;
    const next = Math.max(0, Math.min(n - 1, i));
    if (next !== idx) reset();
    idx = next;
    track.scrollTo({ left: idx * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    countEl.textContent = n > 1 ? (idx + 1) + ' / ' + n : '';
    thumbs.forEach((b, k) => b.setAttribute('aria-current', String(k === idx)));
    const pv = dlg.querySelector('[data-z=prev]'); const nx = dlg.querySelector('[data-z=next]');
    if (pv) pv.disabled = idx === 0;
    if (nx) nx.disabled = idx === n - 1;
    load(idx);
    apply(false);
  }

  /* Mouse y dedos: clic para acercar (PC), doble toque o pellizco (celular), arrastrar para mover o cambiar de foto. */
  function gestures() {
    const pts = new Map();
    let g = null; let lastTap = 0;
    const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
    const local = (x, y) => { const r = rect(); return { x: x - r.left, y: y - r.top }; };
    const follow = (e) => {
      const c = local(e.clientX, e.clientY);
      tx = c.x * (1 - s); ty = c.y * (1 - s); clamp(); apply(false);
    };
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      try { track.setPointerCapture(e.pointerId); } catch (x) { /* sin captura */ }
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 2) {
        const [a, b] = [...pts.values()];
        const c = local((a.x + b.x) / 2, (a.y + b.y) / 2);
        g = { type: 'pinch', d0: dist(a, b) || 1, s0: s, px: (c.x - tx) / s, py: (c.y - ty) / s };
      } else if (pts.size === 1) {
        g = { type: 'one', x0: e.clientX, y0: e.clientY, tx0: tx, ty0: ty, sl0: track.scrollLeft, moved: false, mouse: e.pointerType === 'mouse' };
      }
    });
    track.addEventListener('pointermove', (e) => {
      if (!pts.has(e.pointerId)) {
        if (e.pointerType === 'mouse' && s > 1 && !g) follow(e);
        return;
      }
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (!g) return;
      if (g.type === 'pinch' && pts.size >= 2) {
        const [a, b] = [...pts.values()];
        const c = local((a.x + b.x) / 2, (a.y + b.y) / 2);
        s = Math.min(MAX, Math.max(1, g.s0 * dist(a, b) / g.d0));
        tx = c.x - s * g.px; ty = c.y - s * g.py; clamp(); apply(false);
      } else if (g.type === 'one') {
        const dx = e.clientX - g.x0; const dy = e.clientY - g.y0;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) g.moved = true;
        if (g.mouse) { if (s > 1) follow(e); return; }
        if (s > 1) { tx = g.tx0 + dx; ty = g.ty0 + dy; clamp(); apply(false); }
        else track.scrollLeft = g.sl0 - dx;
      }
    });
    const end = (e) => {
      if (!pts.has(e.pointerId)) return;
      pts.delete(e.pointerId);
      if (!g) return;
      if (g.type === 'pinch') {
        if (pts.size === 1) {
          const p = [...pts.values()][0];
          g = { type: 'one', x0: p.x, y0: p.y, tx0: tx, ty0: ty, sl0: track.scrollLeft, moved: true, mouse: false };
        } else {
          if (s < 1.05) { s = 1; tx = 0; ty = 0; apply(true); }
          g = null;
        }
        return;
      }
      if (pts.size > 0) return;
      const c = local(e.clientX, e.clientY);
      if (!g.moved && e.type === 'pointerup') {
        if (g.mouse) zoomAt(s > 1 ? 1 : CLICK, c.x, c.y, true);
        else if (e.timeStamp - lastTap < 320) { zoomAt(s > 1 ? 1 : CLICK, c.x, c.y, true); lastTap = 0; }
        else lastTap = e.timeStamp;
      } else if (!g.mouse && s === 1) {
        const dx = e.clientX - g.x0;
        go(Math.abs(dx) > 50 ? idx + (dx < 0 ? 1 : -1) : idx, true);
      }
      g = null;
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
  }

  let opener = null;
  function open(i) {
    if (!dlg) build();
    opener = document.activeElement;
    idx = -1;
    dlg.showModal();
    document.body.classList.add('pp-lock');
    requestAnimationFrame(() => go(i, false));
    let seen = false;
    try { seen = sessionStorage.getItem('pp_zoom_hint') === '1'; sessionStorage.setItem('pp_zoom_hint', '1'); } catch (e) { /* sin almacenamiento */ }
    if (!seen) {
      hintEl.textContent = fine.matches ? 'Haz clic en la foto para acercar' : 'Toca dos veces o usa dos dedos para acercar';
      hintEl.classList.add('is-on');
      setTimeout(() => hintEl.classList.remove('is-on'), 3200);
    }
  }
  function onClose() {
    document.body.classList.remove('pp-lock');
    reset();
    /* La galería de la ficha queda en la misma foto. */
    if (typeof gal.show === 'function') gal.show(idx);
    const list = gal.querySelector('.pp-gal__list');
    if (list && list.scrollWidth > list.clientWidth + 1) list.scrollTo({ left: idx * list.clientWidth, behavior: 'auto' });
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  const items = [...gal.querySelectorAll('.pp-gal__item')];
  function current() {
    const list = gal.querySelector('.pp-gal__list');
    if (list && list.scrollWidth > list.clientWidth + 1) return Math.round(list.scrollLeft / (list.clientWidth || 1));
    const a = items.findIndex((li) => li.classList.contains('is-active'));
    return a < 0 ? 0 : a;
  }
  gal.addEventListener('click', (e) => {
    if (e.target.closest('[data-pp-zoom-open]')) { e.preventDefault(); open(current()); return; }
    const li = e.target.closest('.pp-gal__item');
    if (li && e.target.tagName === 'IMG') open(Math.max(0, items.indexOf(li)));
  });
})();
